export default __webpack_public_path__ + "static/media/pvilla4-2.33703082.jpg";